import httpClient from "../httpClient"

import { formatData } from "../request"
import { encodeRequestParameters } from "../request"

import { plagesFormat } from "../formats"

export function getPlages(data) {
    data = formatData(plagesFormat, data)
    const params = encodeRequestParameters(data)

    return httpClient
        .get(`/plage`, { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}
